export default {
  SEARCH_BOX_PLACEHOLDER: 'Search by SKU, VIN or Keyword',
  CLEAR_TEXT: '<rt-virtual template="icons/reset" />',
};
